module.exports = __webpack_public_path__ + "media/images/flags/cw-40e4f5005615c2125016c82ecdd719f7.svg";